/* RESPONSIBLE TEAM: team-frontend-tech */
import { helper as buildHelper } from '@ember/component/helper';
import { formatSeconds } from 'embercom/lib/duration-formatter';

export default buildHelper(function ([seconds], options) {
  return formatSeconds(seconds, options);
});
